export default {
    deleteModalConfirm(item) {
        this.$root.$emit('alertDeleteConfirm', item)
    }
}